// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import LabeledCurrency from '../../../shared/components/labeled-currency';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {buildDealer} from '../../../shared/services/build-dealer';

const DealerItem = props =>
    <section className='dealer-item'>
        {props.dealer.requestStatus.key === 'NEW' ?
            <label className='account-name-label'>{props.dealer.responsibleAccount.name}</label> :
            <Checkbox
                id={props.dealer.responsibleAccount.account}
                onChange={props.handleDealerChange}
                selected={props.initialState[props.dealer[props.uid]] || false}
            >
                {props.dealer.responsibleAccount.name}
            </Checkbox>}
        <section>
            <div className='dealer-location'>
                {buildDealer(props.dealer.responsibleAccount, '01')}
            </div>
            <div className='dealer-labor-rate-change-details'>
                {
                    props.dealer.rates.map(rate =>
                        <LabeledCurrency
                            data={rate.currentRate}
                            key={rate.description}
                            label={rate.description}
                            shouldTranslate={false}
                        />
                    )
                }
            </div>
        </section>
    </section>;

DealerItem.propTypes = {
    dealer: PropTypes.instanceOf(LaborRate).isRequired,
    handleDealerChange: PropTypes.func.isRequired,
    initialState: PropTypes.object.isRequired,
    uid: PropTypes.string.isRequired
};

export default DealerItem;




// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/components/dealer-item.js